// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"8c9d9249","213":"d460e2da","239":"07641345","381":"551f9f2d","455":"9db66a00","657":"38770bca"}[chunkId] + ".chunk.js";
};